import React, { useEffect, useState} from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { TextField, Tooltip } from "@mui/material"
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DoneIcon from '@mui/icons-material/Done';
import GradingIcon from '@mui/icons-material/Grading';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import useAxiosProtect from "../../../../../../hooks/useAxiosProtect";
import { HelpCenter } from "@mui/icons-material";
import { sensorSuppliers, waterUnitTypes, electricUnitTypes, gasUnitTypes, steamUnitTypes, temperatureUnitTypes } from "../../../../../../example_data/dropdowns/clientModal/loggingComponents";
import SensorForm from "./modal_forms/SensorForm";
import SupplierForm from "./modal_forms/SupplierForm";
import ConfirmationPrompt from "./modal_forms/ConfirmationPrompt";
import ReviewPage from "./modal_forms/ReviewPage";
import QTCurrentForm from "./modal_forms/QTCurrentForm";

import useAuth from "../../../../../../hooks/useAuth";

// Flowie Modal
const SensorModal = props => {
    const axiosProtect = useAxiosProtect();
    const {auth} = useAuth();
    const [recipientOptions, setRecipientOptions] = useState([]);
    const [recipientIds, setRecipientIds] = useState([]);
    const [recipientLoading, setRecipientLoading] = useState(false);
    const [recipientLoadError, setRecipientLoadError] = useState('');
    const [recipientError, setRecipientError] = useState('');
    const siteId = (props.modalState === 'edit' ? props.sensorToEdit?.site_id : null) || Number(window.location.pathname.split('/').filter(Boolean).pop());


    const intRegex = /^-?\d*$/;
    const floatRegex = /^(-?\d*\.?\d*)?$/;

    const [steamPressure, setSteamPressure] = useState('');
    const [steamTemperature, setSteamTemperature] = useState('');
    const [steamError, setSteamError] = useState('');
    const [page, setPage] = useState(1);
    const [serverError, setServerError] = useState('');

    //supplier form
    const [createForm, setCreateForm] = useState({
        name: {value: '', error: ''},
        supplier: {value: '', error: ''},
        unitType: {value: null, error: ''},
    });

    const [unitTypes, setUnitTypes] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    const [measurementCategories, setMeasurementCategories] = useState({options: [], value: '', error:''});
    const [quantities, setQuantities] = useState({options: [], value: '', error:''});
    const [units, setUnits] = useState({options: [], value: '', error:''});

    //supplier form
    const [deviceName, setDeviceName] = useState('');
    const [deviceNameError, setDeviceNameError] = useState('');

    const [deviceLocationName, setDeviceLocationName] = useState('');
    const [deviceLocationNameError, setDeviceLocationNameError] = useState('');

    const [deviceType, setDeviceType] = useState('Hoboware');
    const [deviceTypeError, setDeviceTypeError] = useState('');

    const [accountName, setAccountName] = useState('');
    const [accountNameError, setAccountNameError] = useState('');

    const [centricaSiteName, setCentricaSiteName] = useState('');
    const [centricaSiteNameError, setCentricaSiteNameError] = useState('');

    const [deveui, setDeveui] = useState('');
    const [deveuiError, setDeveuiError] = useState('');

    const [batteryThreshold, setBatteryThreshold] = useState('20');
    const [batteryThresholdError, setBatteryThresholdError] = useState('');

    const [rssiThreshold, setRssiThreshold] = useState('-86');
    const [rssiThresholdError, setRssiThresholdError] = useState('');

    const [snrThreshold, setSnrThreshold] = useState('10');
    const [snrThresholdError, setSnrThresholdError] = useState('');

    const [intervalMinutes, setIntervalMinutes] = useState('');
    const [intervalMinutesError, setIntervalMinutesError] = useState('');

    const [gapMinutes, setGapMinutes] = useState('');
    const [gapMinutesError, setGapMinutesError] = useState('');

    const [alertLabsAccount, setAlertLabsAccount] = useState('Enviro-Stewards');

    // specs form
    const [voltage, setVoltage] = useState('');
    const [voltageError, setVoltageError] = useState('');

    const [powerFactor, setPowerFactor] = useState('');
    const [powerFactorError, setPowerFactorError] = useState('');

    const [phaseType, setPhaseType] = useState('3-phase');
    const [phaseTypeError, setPhaseTypeError] = useState('');

    const [channelCount, setChannelCount] = useState('1');

    const [hasVfd, setHasVfd] = useState(false);
    const [hasVfdError, setHasVfdError] = useState('');

    useEffect(() => {
        if (!['add', 'edit'].includes(props.modalState) || createForm.supplier.value !== 'Milesight') return;
        let active = true;
        setRecipientLoading(true);
        setRecipientLoadError('');
        setRecipientError('');
        setRecipientOptions([]);
        setRecipientIds([]);
        axiosProtect.get('/auth/query/milesight-alert-recipients', {params: {site_id: siteId}})
            .then(({data}) => {
                if (!active) return;
                setRecipientOptions(data.users);
                const initial = props.modalState === 'edit'
                    ? props.sensorToEdit?.notification_recipient_ids || []
                    : [auth.id];
                setRecipientIds(initial.filter(id => data.users.some(user => user.id === id)));
            }).catch(() => {
                if (active) setRecipientLoadError('Unable to load notification recipients. Close and reopen the form to retry.');
            }).finally(() => { if (active) setRecipientLoading(false); });
        return () => { active = false; };
    }, [props.modalState, props.sensorToEdit, siteId, auth.id, createForm.supplier.value, axiosProtect]);


    const updateCreateFormValue = (field, value) => {
        setCreateForm(prev => ({
            ...prev,
            [`${field}`]: {
                ...prev[`${field}`],
                value
            }
        }))
    }

    const updateValidSuppliers = () => {
        let supplierCopy = [];

        for(let i = 0;i<sensorSuppliers.length;++i){
            if(sensorSuppliers[i].utilities.includes(props.utility)) supplierCopy.push(sensorSuppliers[i].value);
        }

        setSuppliers([...supplierCopy]);

        if(supplierCopy.length > 0){
            setCreateForm(prev => ({
                ...prev,
                ['supplier']: {
                    ...prev['supplier'],
                    value: supplierCopy[0]
                }
            }))
        }
    }

    const getAllowedSensorSpecs = () => {
        axiosProtect.get(`/v2s/v2-sensors/allowed-specs?utility=${props.utility}`).then(response => {
            setMeasurementCategories(prev => ({
                ...prev, 
                options: [...response.data.measurementCategories],
                value: props.modalState === 'edit'
                    ? props.sensorToEdit.measurement_category_id
                    : response.data.measurementCategories.length === 1 ? response.data.measurementCategories[0].id : ''
            }));

            setQuantities(prev => ({
                ...prev, 
                options: [...response.data.quantities],
                value: props.modalState === 'edit'
                    ? props.sensorToEdit.quantity_id
                    : response.data.quantities.length === 1 ? response.data.quantities[0].id : ''
            }));

            setUnits(prev => ({
                ...prev, 
                options: [...response.data.units],
                value: props.modalState === 'edit'
                    ? props.sensorToEdit.unit_id
                    : response.data.units.length === 1 ? response.data.units[0].id : ''
            }));

            console.log(response.data);
        }).catch(error => {});
    }

    useEffect(() => {
        if(props.modalState === undefined) return;

        const utilityUnitTypes = props.utility === 'water' ? waterUnitTypes
            : props.utility === 'electricity' ? electricUnitTypes
            : props.utility === 'gas' ? gasUnitTypes
            : props.utility === 'steam' ? steamUnitTypes
            : temperatureUnitTypes;

        setUnitTypes(utilityUnitTypes);

        if(props.modalState === 'edit' && props.sensorToEdit){
            const sensor = props.sensorToEdit;

            setCreateForm({
                name: {value: sensor.name || '', error: ''},
                supplier: {value: sensor.supplier_name || '', error: ''},
                unitType: {
                    value: utilityUnitTypes.find(type => type.value === sensor.unit_type) || null,
                    error: ''
                }
            });
            setSuppliers([sensor.supplier_name]);
            setDeviceName(sensor.device_name || '');
            setDeviceType(sensor.device_type || 'Hoboware');
            setDeviceLocationName(sensor.device_location_name || '');
            setAlertLabsAccount(sensor.account_name || 'Enviro-Stewards');
            setCentricaSiteName(sensor.centrica_site_name || '');
            setDeveui(sensor.deveui || '');
            setBatteryThreshold(sensor.battery_threshold?.toString() || '20');
            setRssiThreshold(sensor.rssi_threshold?.toString() || '-86');
            setSnrThreshold(sensor.snr_threshold?.toString() ?? '10');
            setIntervalMinutes(sensor.expected_interval_minutes?.toString() || '');
            setGapMinutes(sensor.gap_minutes?.toString() || '');
            setVoltage(sensor.voltage?.toString() || '');
            setPowerFactor(sensor.assumed_power_factor?.toString() || '');
            setPhaseType(sensor.phase_type || '3-phase');
            setChannelCount(sensor.channel_count?.toString() || '1');
            setHasVfd(Boolean(sensor.has_vfd));
            setSteamPressure(sensor.operating_pressure_psig?.toString() ?? '');
            setSteamTemperature(sensor.operating_temperature_f?.toString() ?? '');
        }else{
            updateValidSuppliers();
        }

        getAllowedSensorSpecs();
    }, [props.modalState]);

    const buildTitle = () => {
        if(props.modalState === 'image') return 'Sensor image';

        let action = `${props.modalState?.substring(0,1).toUpperCase()}${props.modalState?.substring(1)}`;
        return `${action} ${props.utility} sensor`;
    }

    const generatePayload = () => {
        let payload = {
            name: createForm.name.value,
            site_id: siteId,
            supplier: createForm.supplier.value,
            unit_type: createForm.unitType.value.value,

            quantity_id: parseInt(quantities.value),
            measurement_category_id: parseInt(measurementCategories.value),
            unit_id: parseInt(units.value)
        };

        if(createForm.supplier.value === 'AlertLabs'){
            payload.device_name = deviceName;
            payload.device_location_name = deviceLocationName;
            payload.account_name = alertLabsAccount;

        }else if(createForm.supplier.value === 'Edgecom'){
            payload.device_name = deviceName;
            payload.device_location_name = deviceLocationName;

        }else if(createForm.supplier.value === 'Milesight'){
            payload.notification_recipient_ids = recipientIds;
            payload.deveui = deveui;
            payload.battery_threshold = parseInt(batteryThreshold);
            payload.rssi_threshold = parseInt(rssiThreshold);
            payload.snr_threshold = parseInt(snrThreshold);
        }else if(createForm.supplier.value === 'Offline'){
            payload.device_type = deviceType;
        }

        if(createForm.supplier.value !== 'Offline'){
            payload.interval_minutes = parseInt(intervalMinutes);
            payload.gap_minutes = parseInt(gapMinutes);
        }

        if(props.utility === 'electricity' && Number(quantities.value) === 7){
            payload.voltage = parseFloat(voltage);
            payload.power_factor = parseFloat(powerFactor);
            payload.phase_type = phaseType;
            payload.has_vfd = hasVfd;
            if(createForm.supplier.value === 'Milesight') payload.channel_count = parseInt(channelCount);
        }

        if (props.utility === 'steam') {
            payload.operating_pressure_psig = Number(steamPressure);
            payload.operating_temperature_f = Number(steamTemperature);
        }
        return payload;
    }

    const validateSensorForm = () => {
        let isValid = true;

        let tempForm = {...createForm};

        if(tempForm.name.value.trim() === ''){
            tempForm.name.error = 'Required';
            isValid = false;
        }else tempForm.name.error = '';

        if(tempForm.supplier.value.trim() === ''){
            tempForm.supplier.error = 'Required';
            isValid = false;
        }else tempForm.supplier.error = '';

        if(!tempForm.unitType.value){
            tempForm.unitType.error = 'Required';
            isValid = false;
        }else tempForm.unitType.error = '';

        setCreateForm(tempForm);

        console.log(measurementCategories)

        if(measurementCategories.value === ''){
            setMeasurementCategories(prev => ({
                ...prev,
                'error': 'Required'
            }));
            isValid = false;

        }else setMeasurementCategories(prev => ({
                ...prev,
                'error': ''
            }));

        if(quantities.value === ''){
            setQuantities(prev => ({
                ...prev,
                'error': 'Required'
            }));
            isValid = false;
        }else setQuantities(prev => ({
                ...prev,
                'error': ''
            }));

        if(units.value === ''){
            setUnits(prev => ({
                ...prev,
                'error': 'Required'
            }));
            isValid = false;
        }else setUnits(prev => ({
                ...prev,
                'error': ''
            }));

        return isValid;
    }

    const validateSupplierForm = () => {
        let isValid = true;
        if (createForm.supplier.value === 'Milesight') {
            const message = recipientLoading ? 'Wait for recipients to load' : recipientLoadError ||
                (recipientIds.length ? '' : 'Select at least one notification recipient');
            setRecipientError(message);
            if (message) isValid = false;
        }

        if(createForm.supplier.value === 'AlertLabs' || createForm.supplier.value === 'Edgecom'){
            if(deviceName.trim() === ''){
                setDeviceNameError('Required');
                isValid = false;
            }else setDeviceNameError('');

            if(deviceLocationName.trim() === ''){
                setDeviceLocationNameError('Required');
                isValid = false;
            }else setDeviceLocationNameError('');

        }else if(createForm.supplier.value === 'Milesight'){
            console.log(deveui)
            console.log(deveui.trim() === '')
            if(deveui.trim() === ''){
                setDeveuiError('Required');
                isValid = false;
            }else setDeveuiError('');

            if(rssiThreshold.trim() === ''){
                setRssiThresholdError('Required');
                isValid = false;
            }else if(!intRegex.test(rssiThreshold)){
                setRssiThresholdError('Must be an integer');
                isValid = false;
            }else if(parseInt(rssiThreshold) > -30 || parseInt(rssiThreshold) < -90){
                setRssiThresholdError('RSSI must range from [-30, -90]');
                isValid = false;
            }else setRssiThresholdError('');

            if(batteryThreshold.trim() === ''){
                setBatteryThresholdError('Required');
                isValid = false;
            }else if(!intRegex.test(batteryThreshold)){
                setBatteryThresholdError('Must be an integer');
                isValid = false;
            }else if(parseInt(batteryThreshold) > 99 || parseInt(batteryThreshold) < 1){
                setBatteryThresholdError('Battery must range from [1, 99]');
                isValid = false;
            }else setBatteryThresholdError('');

            if(snrThreshold.trim() === ''){
                setSnrThresholdError('Required');
                isValid = false;
            }else if(!intRegex.test(snrThreshold)){
                setSnrThresholdError('Must be an integer');
                isValid = false;
            }else if(parseInt(snrThreshold) < 0 || parseInt(snrThreshold) > 30){
                setSnrThresholdError('SNR must range from [0, 30]');
                isValid = false;
            }else setSnrThresholdError('');
        }else if(createForm.supplier.value === 'Offline'){
            if(!['Hoboware', 'Ultrasonic'].includes(deviceType)){
                setDeviceTypeError('Required');
                isValid = false;
            }else setDeviceTypeError('');
        }

        if(createForm.supplier.value !== 'Offline' && intervalMinutes.trim() === ''){
            setIntervalMinutesError('Required');
            isValid = false;
        }else if(!intRegex.test(intervalMinutes)){
            setIntervalMinutesError('Must be a positive integer greater than zero');
            isValid = false;
        }else if(parseInt(intervalMinutes) <= 0){
            setIntervalMinutesError('Must be a positive integer');
            isValid = false;
        }else setIntervalMinutesError('');

        if(createForm.supplier.value !== 'Offline' && gapMinutes.trim() === ''){
            setGapMinutesError('Required');
            isValid = false;
        }else if(!intRegex.test(gapMinutes)){
            setGapMinutesError('Must be a positive integer greater than zero');
            isValid = false;
        }else if(parseInt(gapMinutes) <= 0){
            setGapMinutesError('Must be a positive integer');
            isValid = false;
        }else if(parseInt(gapMinutes) <= parseInt(intervalMinutes)){
            setGapMinutesError('Gap minutes must be greater than interval');
            isValid = false;
        }else setGapMinutesError('');

        return isValid;
    }

    const validateQTCurrentForm = () => {
        let isValid = true;
        const parsedVoltage = Number(voltage);
        const parsedPowerFactor = Number(powerFactor);

        if(voltage.trim() === '' || !Number.isFinite(parsedVoltage) || parsedVoltage <= 0){
            setVoltageError('Must be greater than 0');
            isValid = false;
        }else setVoltageError('');

        if(powerFactor.trim() === '' || !Number.isFinite(parsedPowerFactor) || parsedPowerFactor < 0 || parsedPowerFactor > 1){
            setPowerFactorError('Must range from 0 to 1');
            isValid = false;
        }else setPowerFactorError('');

        if(!['1-phase', '3-phase'].includes(phaseType)){
            setPhaseTypeError('Required');
            isValid = false;
        }else setPhaseTypeError('');

        return isValid;
    }

    const requiresQTCurrent = props.utility === 'electricity' && Number(quantities.value) === 7;
    const requiresSteam = props.utility === 'steam';
    const reviewPage = requiresQTCurrent || requiresSteam ? 4 : 3;

    const addSensor = () => {
        axiosProtect.post('/v2s/v2-sensors/', generatePayload()).then(response => {
            props.addSensor(response.data.sensor);
            props.closeModal();
        }).catch(error => {
            setServerError(error.response.data.error);
        });
    }

    const editSensor = () => {
        const payload = generatePayload();
        delete payload.supplier;
        payload.sensor_id = props.sensorToEdit.sensor_id || props.sensorToEdit.id;

        axiosProtect.put('/v2s/v2-sensors/', payload).then(response => {
            props.editSensor(response.data.sensor);
            props.closeModal();
        }).catch(error => {
            setServerError(error.response?.data?.error || 'Unable to edit sensor');
        });
    }

    const toggleSensor = async () => {
        const sensor = props.sensorToToggle;

        axiosProtect.put('/v2s/v2-sensors/toggle-active', {
            sensor_id: sensor.sensor_id || sensor.id,
            site_id: sensor.site_id
        }).then(response => {
            props.toggleSensor(response.data.sensor);
            props.closeModal();
        }).catch(error => {
            setServerError(error.response?.data?.error || 'Unable to toggle sensor');
        });
    }

    const deleteSensor = async () => {
        const sensorId = props.sensorToDelete?.sensor_id || props.sensorToDelete?.id;
        const siteId = props.sensorToDelete?.site_id || parseInt(window.location.href.split('/').slice(-1));

        axiosProtect.delete('/v2s/v2-sensors/', {
            params: {
                sensor_id: sensorId,
                site_id: siteId
            }
        }).then(() => {
            props.deleteSensor(sensorId);
            props.closeModal();
        }).catch(error => {
            setServerError(error.response?.data?.error || 'Unable to delete sensor');
        });
    }

    const addImage = async () => {

    }

    const incrementPage = () => {
        setServerError('');

        if(page === 1){
            if(!validateSensorForm()) return;
            setPage(page + 1);

        }else if(page === 2){
            if(!validateSupplierForm())return;
            setPage(page + 1);

        }else if(page === 3 && requiresSteam){
            if (steamPressure.trim() === '' || steamTemperature.trim() === '' ||
                !Number.isFinite(Number(steamPressure)) || Number(steamPressure) < 0 ||
                !Number.isFinite(Number(steamTemperature))) {
                setSteamError('Enter a finite operating pressure (psig, at least zero) and temperature (°F).');
                return;
            }
            setSteamError('');
            setPage(page + 1);
        }else if(page === 3 && requiresQTCurrent){
            if(!validateQTCurrentForm()) return;
            setPage(page + 1);

        }else if(page === reviewPage){
            if (!validateSupplierForm()) { setPage(2); return; }
            if(props.modalState === 'edit') editSensor();
            else if(props.modalState === 'add') addSensor();
        }
    }

    const decrementPage = () => {
        setServerError('');
        setPage(page - 1);
    }

    return (
        <>
        <Modal show={props.modalState !== undefined} onHide={() => props.closeModal()} 
            backdrop="static" 
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                <h4>{buildTitle()}</h4>
            </Modal.Header>
            <Modal.Body>
                {serverError !== '' && <p style={{color:'red', textAlign:'center'}}>{serverError}</p>}

                {
                    ['toggle', 'delete'].includes(props.modalState) && 
                    <ConfirmationPrompt
                        modalState={props.modalState}
                        sensorToDelete={props.sensorToDelete}
                        sensorToToggle={props.sensorToToggle}
                    />
                }
                {
                    props.modalState === 'image' &&
                    <div>
                        <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px'}}>
                            {(Array.isArray(props.sensorToImage?.images) ? props.sensorToImage.images : [props.sensorToImage?.images])
                                .filter(Boolean)
                                .map((url, index) => (
                                    <a key={index} href={url} target="_blank" rel="noopener noreferrer">
                                        <img src={url} alt={`sensor-${index}`} style={{width: '150px', height: '150px', objectFit: 'cover', borderRadius: '4px'}}/>
                                    </a>
                                ))}
                        </div>
                        {!props.imageReadOnly && <Button variant="outline-secondary" onClick={() => {
                            props.triggerFileUpload(props.sensorToImage);
                            props.closeModal();
                        }}>
                            Replace
                        </Button>}
                    </div>
                }
                {
                    ['add', 'edit'].includes(props.modalState) &&
                    (
                        <>
                        {
                            page === 1 && 
                            <SensorForm 
                                modalState={props.modalState} 
                                utility={props.utility} 
                                createForm={createForm} 
                                updateCreateFormValue={updateCreateFormValue}
                                
                                unitTypes={unitTypes}
                                suppliers={suppliers}
                                measurementCategories={measurementCategories}
                                setMeasurementCategories={setMeasurementCategories}
                                units={units}
                                setUnits={setUnits}
                                quantities={quantities}
                                setQuantities={setQuantities}
                            />
                        }
                        {
                            page === 2 && 
                            <SupplierForm
                                createForm={createForm}
                                updateCreateFormValue={updateCreateFormValue}

                                suppliers={suppliers}
                                modalState={props.modalState} 

                                waterUnitTypes={waterUnitTypes}
                                electricUnitTypes={electricUnitTypes}
                                gasUnitTypes={gasUnitTypes}
                                temperatureUnitTypes={temperatureUnitTypes}

                                deviceName={deviceName}
                                setDeviceName={setDeviceName}
                                deviceNameError={deviceNameError}
                                setDeviceNameError={setDeviceNameError}

                                deviceLocationName={deviceLocationName}
                                setDeviceLocationName={setDeviceLocationName}
                                deviceLocationNameError={deviceLocationNameError}
                                setDeviceLocationNameError={setDeviceLocationNameError}

                                deviceType={deviceType}
                                setDeviceType={setDeviceType}
                                deviceTypeError={deviceTypeError}
                                setDeviceTypeError={setDeviceTypeError}

                                accountName={accountName}
                                setAccountName={setAccountName}
                                accountNameError={accountNameError}
                                setAccountNameError={setAccountNameError}

                                centricaSiteName={centricaSiteName}
                                setCentricaSiteName={setCentricaSiteName}
                                centricaSiteNameError={centricaSiteNameError}
                                setCentricaSiteNameError={setCentricaSiteNameError}

                                deveui={deveui}
                                setDeveui={setDeveui}
                                deveuiError={deveuiError}
                                setDeveuiError={setDeveuiError}

                                batteryThreshold={batteryThreshold}
                                setBatteryThreshold={setBatteryThreshold}
                                batteryThresholdError={batteryThresholdError}
                                setBatteryThresholdError={setBatteryThresholdError}

                                rssiThreshold={rssiThreshold}
                                setRssiThreshold={setRssiThreshold}
                                rssiThresholdError={rssiThresholdError}
                                setRssiThresholdError={setRssiThresholdError}

                                snrThreshold={snrThreshold}
                                setSnrThreshold={setSnrThreshold}
                                snrThresholdError={snrThresholdError}
                                setSnrThresholdError={setSnrThresholdError}

                                intervalMinutes={intervalMinutes}
                                setIntervalMinutes={setIntervalMinutes}
                                intervalMinutesError={intervalMinutesError}
                                setIntervalMinutesError={setIntervalMinutesError}

                                gapMinutes={gapMinutes}
                                setGapMinutes={setGapMinutes}
                                gapMinutesError={gapMinutesError}
                                setGapMinutesError={setGapMinutesError}

                                voltage={voltage}
                                setVoltage={setVoltage}
                                voltageError={voltageError}
                                setVoltageError={setVoltageError}

                                powerFactor={powerFactor}
                                setPowerFactor={setPowerFactor}
                                powerFactorError={powerFactorError}
                                setPowerFactorError={setPowerFactorError}

                                phaseType={phaseType}
                                setPhaseType={setPhaseType}
                                phaseTypeError={phaseTypeError}
                                setPhaseTypeError={setPhaseTypeError}

                                hasVfd={hasVfd}
                                setHasVfd={setHasVfd}
                                channelCount={channelCount}
                                setChannelCount={setChannelCount}
                                showChannelCount={createForm.supplier.value === 'Milesight'}
                                hasVfdError={hasVfdError}
                                setHasVfdError={setHasVfdError}

                                alertLabsAccount={alertLabsAccount}
                                setAlertLabsAccount={setAlertLabsAccount}

                                recipientOptions={recipientOptions}
                                recipientIds={recipientIds}
                                setRecipientIds={setRecipientIds}
                                recipientLoading={recipientLoading}
                                recipientError={recipientLoadError || recipientError}
                                setRecipientError={setRecipientError}
                                sensorToEdit={props.sensorToEdit}
                            />
                        }
                        {
                            page === 3 && requiresQTCurrent &&
                            <QTCurrentForm
                                voltage={voltage}
                                setVoltage={setVoltage}
                                voltageError={voltageError}
                                powerFactor={powerFactor}
                                setPowerFactor={setPowerFactor}
                                powerFactorError={powerFactorError}
                                phaseType={phaseType}
                                setPhaseType={setPhaseType}
                                phaseTypeError={phaseTypeError}
                                hasVfd={hasVfd}
                                setHasVfd={setHasVfd}
                            />
                        }
                        {
                            page === 3 && requiresSteam && <div>
                                <h5>Saturated steam conditions</h5>
                                <TextField fullWidth margin="normal" label="Operating pressure (psig)" value={steamPressure} onChange={e => setSteamPressure(e.target.value)}/>
                                <TextField fullWidth margin="normal" label="Operating temperature (°F)" value={steamTemperature} onChange={e => setSteamTemperature(e.target.value)}/>
                                <p>Pressure determines saturated-vapor enthalpy. Temperature differences over 10 °F from saturation are flagged. Pressure must be within the configured steam table.</p>
                                {steamError && <p role="alert" style={{color:'red'}}>{steamError}</p>}
                            </div>
                        }
                        {
                            page === reviewPage &&
                            <ReviewPage
                                createForm={createForm}
                                measurementCategories={measurementCategories}
                                quantities={quantities}
                                units={units}
                                notificationRecipients={recipientOptions.filter(user => recipientIds.includes(user.id))}
                                deveui={deveui}
                                deviceName={deviceName}
                                deviceLocationName={deviceLocationName}
                                batteryThreshold={batteryThreshold}
                                rssiThreshold={rssiThreshold}
                                snrThreshold={snrThreshold}
                                alertLabsAccount={alertLabsAccount}
                                intervalMinutes={intervalMinutes}
                                gapMinutes={gapMinutes}
                                voltage={voltage}
                                powerFactor={powerFactor}
                                phaseType={phaseType}
                                hasVfd={hasVfd}
                                channelCount={channelCount}
                                showSteam={requiresSteam}
                                steamPressure={steamPressure}
                                steamTemperature={steamTemperature}
                                showQTCurrent={requiresQTCurrent}
                                deviceType={deviceType}
                            />
                        }
                        </>
                    )
                }
            </Modal.Body>
            <Modal.Footer>
                    {/* <Button
                        // variant={props.modalState === 'toggle' ? 'primary' : 'danger'}
                        style={{backgroundColor: 'rgb(8,114,182)'}}
                        type='submit'
                        onClick={() => {
                            if (props.modalState === 'delete') {
                                deleteFlowie();
                            } else if (props.modalState === 'add') {
                                createFlowie();
                            } else if (props.modalState === 'edit') {
                                editFlowie();
                            } else if (props.modalState === 'toggle') {
                                props.toggleFlowieStatus(props.flowieModalData.id, props.flowieModalData.flowie_location_name !== undefined ? 'flowie' : props.flowieModalData.deveui !== undefined ? 'milesight' : 'edgecom')
                            }
                        }}
                        >
                            {props.modalState === 'add' ? 'Create'
                            :props.modalState === 'edit' ? 'Edit'
                            :props.modalState === 'delete' ? 'Delete'
                            :props.modalState === 'toggle' ? 'Confirm'
                            : ''}
                    </Button> */}
                    {props.modalState === 'delete' ? (
                        <Button variant="danger" onClick={deleteSensor}>
                            Delete
                        </Button>
                    ) : props.modalState === 'toggle' ? (
                        <Button onClick={toggleSensor}>
                            Confirm
                        </Button>
                    ) : props.modalState === 'image' ? null
                    : <div style={{display:'flex', flexDirection:'row', width:'100%'}}>
                        {page > 1 && <IconButton aria-label="sensor-create-back" onClick={decrementPage}>
                            <ArrowBackIcon />
                        </IconButton>}
    
                        <div style={{flex:'10'}}></div>
    
                        <IconButton aria-label="sensor-create-next" onClick={incrementPage}>
                            {page === 1 ? <ArrowForwardIcon /> : page === reviewPage ? <DoneIcon /> : page === reviewPage - 1 ? <GradingIcon/> : <ArrowForwardIcon />}
                        </IconButton>
                    </div>}
            </Modal.Footer>
        </Modal>
        </>
      );
  }

export default SensorModal;
